"use client";
import React from "react";

type Props = {
  children: React.ReactNode;
  /** Pixels from the bottom that count as "near the end" */
  bottomOffset?: number; // default: 200
};

const HomeStickyWrapper = ({ children, bottomOffset = 600 }: Props) => {
  const rafId = React.useRef<number | null>(null);

  // Toggle classes on #banner-section when near the bottom of the page
  React.useEffect(() => {
    const el = document.getElementById("banner-section");
    if (!el) return;

    const applyNearBottomState = () => {
      const doc = document.documentElement;
      const scrollY = window.scrollY || window.pageYOffset;
      const viewport = window.innerHeight;
      const scrollHeight = doc.scrollHeight;
      const nearBottom = scrollY + viewport >= scrollHeight - bottomOffset;

      if (nearBottom) {
        el.classList.add("opacity-0", "pointer-events-none", "-z-20");
      } else {
        el.classList.remove("opacity-0", "pointer-events-none", "-z-20");
      }
    };

    const onScrollOrResize = () => {
      if (rafId.current != null) cancelAnimationFrame(rafId.current);
      rafId.current = requestAnimationFrame(applyNearBottomState);
    };

    // Initial run + listeners
    applyNearBottomState();
    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);
    window.addEventListener("orientationchange", onScrollOrResize);

    return () => {
      if (rafId.current != null) cancelAnimationFrame(rafId.current);
      window.removeEventListener("scroll", onScrollOrResize);
      window.removeEventListener("resize", onScrollOrResize);
      window.removeEventListener("orientationchange", onScrollOrResize);
    };
  }, [bottomOffset]);

  return (
    <section className="z-30 mt-[570px] min-[350px]:mt-[550px] min-[404px]:mt-[530px] min-[431px]:mt-[488px] min-[523px]:mt-[460px]  min-[592px]:mt-[430px] min-[640px]:mt-[530px] min-[768px]:mt-[660px] min-[790px]:mt-[595px] min-[899px]:mt-[580px]  min-[1024px]:mt-[825px] min-[1093px]:mt-[795px] min-[1260px]:mt-[770px]  min-[1536px]:mt-[880px] min-[1743px]:mt-[910px]  flex flex-col gap-y-16 !overflow-x-hidden ">
      {/* Spacer equal to the banner's current height */}
      {/* <div className="-z-10" style={{ height: bannerHeight }} /> */}

      {/* <section className="opacity-0 pointer-events-none -z-10 overflow-x-hidden">
        <GridBackground>
          <Banner />
        </GridBackground>
        <SectionWrapper hideBottomPadding className="mt-8">
          <Clients />
        </SectionWrapper>
      </section> */}

      <section className="z-30  bg-background ">{children}</section>
    </section>
  );
};

export default HomeStickyWrapper;
